const NAME = "REBUILD_ACCUMULATORS_PAGE";

export default NAME;
